import Attachment from "components/MessageBubble/Attachment";
import { allowedFileExtensions } from "shared/constants";
import { Literals } from "shared/types";

import Dropper from ".";

type Props = {
  selectedFiles: File[];
  onChange: (files: File[]) => void;
  maxFiles: number;
  maxFileSize: number;
  disabled?: boolean;
  copyTexts: Literals;
};

function AttachmentsInput(props: Props) {
  const {
    selectedFiles,
    onChange,
    maxFiles,
    maxFileSize,
    disabled,
    copyTexts,
  } = props;

  return selectedFiles.length > 0 ? (
    <div className="form-input-container flex flex-col gap-1 pr-14">
      {selectedFiles.map(file => (
        <div key={file.name}>
          <Attachment
            url={URL.createObjectURL(file)}
            fileName={file.name}
            mimetype={file.type}
            fileSize={file.size}
            variant="light"
            onRemoveAttachment={() => {
              !disabled && onChange(selectedFiles.filter(f => f !== file));
            }}
          />
        </div>
      ))}
    </div>
  ) : (
    <div className="form-input-container">
      <Dropper
        allowedExtensions={allowedFileExtensions}
        maxFileSize={maxFileSize}
        onChange={(files: File[]) => {
          onChange(files.slice(0, maxFiles));
        }}
        multiple={true}
        hint={copyTexts.allowedFileExtensionsText}
        copyTexts={copyTexts}
      />
    </div>
  );
}

export default AttachmentsInput;
